import React from 'react';

const CustomView = ({ value1 = '', value2 = '', name1 = '', name2 = '', type = false }) => {
  const showValue1 = name1 && value1;
  const showValue2 = name2 && value2;

  return (
    <>
      {(value1 || value2?.props?.value) && (
        <div className='row mx-4 mt-4'>
          {name1 && (
            <div className={type ? 'col-md-12' : 'col-md-6'}>
              <div className='details-label'>{name1}</div>
              {showValue1 ? (
                <div className='details-value preview-breaks'>{value1}</div>
              ) : (
                <div className='details-value'>---</div>
              )}
            </div>
          )}
          {name2 && (
            <div className='col-md-6'>
              <div className='details-label'>{name2}</div>
              {showValue2 ? (
                <div className='details-value'>{value2}</div>
              ) : (
                <div className='details-value'>---</div>
              )}
            </div>
          )}
        </div>
      )}
    </>
  );
};

export default CustomView;
